<template>
  <div class="qs-list">
    <!-- 提交问题 -->
    <div v-show="!tab">
      <div class="qs-form">
        <div class="form-item" @click="showPicker=true">
          <span class="item-title">{{store.langConfig['QuestionType']}}</span>
          <div class="item-content">
            <span v-if="!isChooseQstype">{{store.langConfig['formQuestionPlace']}}</span>
            <span v-else>{{qsType.text}}</span>
            <van-icon :name="showPicker?'arrow-up':'arrow-down'"></van-icon>
          </div>
        </div>
        <div class="form-item" @click="showCustomPicker=true">
          <span class="item-title">{{store.langConfig['CustomerLanguage']}}</span>
          <div class="item-content">
            <!-- <span v-if="!isChooseCustomer">{{store.langConfig['formCustomerLanguagePlace']}}</span> -->
            <span>{{csType.text}}</span>
            <van-icon :name="showCustomPicker?'arrow-up':'arrow-down'"></van-icon>
          </div>
        </div>
        <div class="form-item">
          <span class="item-title">{{store.langConfig['Content']}}</span>
          <div class="item-content item-text">
            <van-field class="item-textarea" v-model="content" type="textarea" :placeholder="store.langConfig['formContentPlace']" rows="3" :autosize="{maxHeight: 150, minHeight:50}" show-word-limit maxlength="300" @input="changeContent"></van-field>
          </div>
          <span v-if="isChooseQstype" style="color: #606266; white-space: pre-wrap; word-wrap: break-word;">{{qsType.desc}}</span>
        </div>
        <div class="form-item">
          <span class="item-title">{{store.langConfig['AddImage']}}</span>
          <div class="item-file">
            <van-uploader v-model="fileList" :max-size="10*1024*1024" :max-count="5" image-fit="contain" multiple @oversize="onOversize"></van-uploader>
          </div>
          <span style="color: #606266">{{ store.langConfig['formImagePlace'] }}</span>
        </div>
      </div>
      <van-divider></van-divider>
      <div class="btn-commit" @click="submitQs">{{store.langConfig['Summit']}}</div>
    </div>
    <!-- 我的提问 -->
    <div v-show="tab">
      <van-cell icon="brush-o" class="subtitle" :title="store.langConfig['Filter']"></van-cell>
        <div class="btn-group">
          <van-badge class="btn-select" :class="{active: filterType===0}" @click.native="filterType = 0">
            <div >
              <span>{{store.langConfig['InSolution']}}</span>&nbsp;
              <span>{{solvingQsList.length}}</span>
            </div>
          </van-badge>
          <van-badge class="btn-select" :class="{active: filterType===1}" @click.native="filterType = 1">
            <div>
              <span>{{store.langConfig['Completed']}}</span>&nbsp;
              <span>{{solvedQsList.length}}</span>
            </div>
          </van-badge>
        </div>
        <van-cell icon="comment-o" class="subtitle" :title="store.langConfig['WorkOrder']"></van-cell>
        <van-list v-if="showQsList.length" class="box-qs-list">
          <van-cell v-for="item in showQsList" :key="item.questionId" :to="{path:'/customer/detail', query:{ questionId: item.questionId }}">
            <div class="qs-item">
              <span class="qs-title">{{item.content}}</span>
              <span class="qs-time">{{item.updateTime}}</span>
            </div>
          </van-cell>
        </van-list>
        <van-empty v-else></van-empty>
    </div>

    <!-- 弹出层 -->
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker :columns="qsTypeList" :title="store.langConfig['QuestionType']" 
        :cancel-button-text="store.langConfig['Cancel']" :confirm-button-text="store.langConfig['Confirm']" 
        show-toolbar @confirm="confirmQsType($event)" @cancel="showPicker=false"></van-picker>
    </van-popup>
    <van-popup v-model="showCustomPicker" round position="bottom">
      <van-picker :columns="customerList" :title="store.langConfig['CustomerLanguage']" 
        :cancel-button-text="store.langConfig['Cancel']" :confirm-button-text="store.langConfig['Confirm']" 
        show-toolbar @confirm="confirmCustomer($event)" @cancel="showCustomPicker=false"></van-picker>
    </van-popup>
  </div>
</template>

<script>
import {getQuestionType, uploadImage, getQuestionList, addQuestion, getCustomerLanguage} from '@/api'

export default {
  name: 'QsList',
  props: {
    store: Object
  },
  watch: {
    store: {
      deep: true,
      immediate:true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.newStoreInfo = newVal
          this.$nextTick(() => {
            this.getQuestionType()
            this.getQuestionList()
            this.getCustomer()
          })
        }
      }
    }
  },
  data(){
    return {
      questionList: [], //数据源
      solvingQsList: [],
      solvedQsList: [],
      // 过滤工单类型
      filterType: 0,

      qsTypeList: [],
      qsType: '',
      // 弹出窗
      showPicker: false,
      isChooseQstype: false,
      showCustomPicker: false,
      isChooseCustomer: false,
      csType: {},
      title: '',
      content: '',
      fileList: [],

      lockApi: {
        image: false,
        question: false,
      },
      customerList: [],
      newStoreInfo: ''
    }
  },
  computed: {
    // 0 -> 提交问题 1 -> 我的提问
    tab(){
        // 注意默认值与子路由保持一致
      return Number(this.$route.query.type || 0)
    },
    // 实际展示列表
    showQsList(){
      return this.filterType === 0? this.solvingQsList : this.solvedQsList
    }
  },
  methods:{
    changeTitle(value){
      // trim修饰符不生效，因为input事件被重载
      this.title = value.replace(/(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f\ude80-\udeff])|[\u2600-\u2B55]/g, '')
    },
    changeContent(value){
      this.content = value.replace(/(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f\ude80-\udeff])|[\u2600-\u2B55]/g, '')
    },
    // 获取问题类型配置
    getQuestionType(){
      let appId = this.newStoreInfo.userInfo.appId
      let lang = this.newStoreInfo.userInfo.language

      let url = '/v1/question/getQuestionTypes/'+appId+'/'+lang
      getQuestionType(url).then(res=>{
        this.qsTypeList = res.data.map(item=>({id:item.id, text: item.name, desc: item.content}))
        // this.qsType = this.qsTypeList[0]
      })
    },
    confirmQsType(value){
      console.log(value)
      this.qsType = value
      this.showPicker = false
      this.isChooseQstype = true
    },
    confirmCustomer(value) {
      this.csType = value
      this.showCustomPicker = false
      this.isChooseCustomer = true
      this.newStoreInfo.targetLanguage = value.id
    },
    onOversize(){
      this.$toast(this.newStoreInfo.langConfig['ImageOversize']);
    },
    // 提交问题
    submitQs(){
      if (this.fileList.length !== 0) {
        // 先上传图片再提交
        this.uploadImage()
      } else {
        this.addQuestion()
      }
    },
    uploadImage(){
      if (this.lockApi.image) {
        this.$toast(this.newStoreInfo.langConfig['ImageLoading'])
        return false
      }
      this.content = this.content.trim()
      if (this.csType.id === '' || !this.qsType) {
        this.$toast(this.newStoreInfo.langConfig['InputEmpty'])
        return false
      }
      if (this.content === '') {
        this.$toast(this.newStoreInfo.langConfig['TitleContentEmpty'])
        return false
      }

      let formData = new FormData()
      this.fileList.forEach(item => {
        formData.append('imageFiles', item.file)
      })
      formData.append('appId', this.newStoreInfo.userInfo.appId)

      this.lockApi.image = true
      this.newStoreInfo.loading = {
        isShow: true,
        showType: 2
      }
      uploadImage(formData).then(res=>{
        let imgPath = res.data.join('||')
        this.addQuestion(imgPath)
      }, ()=> {
        this.newStoreInfo.loading.isShow = false
      }).finally(()=>{
        this.lockApi.image = false
      })
    },
    addQuestion(path){
      if (this.lockApi.question) {
        this.$toast(this.newStoreInfo.langConfig['QuestionLoading'])
        return false
      }
      this.content = this.content.trim()
      if (this.csType.id === '' || !this.qsType) {
        this.$toast(this.newStoreInfo.langConfig['InputEmpty'])
        return false
      }
      if (this.content === '') {
        this.$toast(this.newStoreInfo.langConfig['TitleContentEmpty'])
        return false
      }

      let {appId, gameZoneId, language, level, roleId, roleName, userId, vipLevel, email, deviceNo, source, gameUserId } = this.newStoreInfo.userInfo

      let data = {
        appId,
        userId: userId || 0,
        roleId,
        roleName,
        level,
        vipLevel,
        gameZoneId,
        language,
        email,
        deviceNo,
        questionType: this.qsType.id,
        questionSubType: '',
        playerLanguage: this.csType.text,
        content: this.content,
        isLogin: userId ? 1 : 0,
        source: source,
        gameUserId: gameUserId,
        questionImagePath: path || ''
      }
      this.lockApi.question = true
      addQuestion(data).then(()=>{
        this.content = ''
        this.fileList = []
        this.$toast.success(this.newStoreInfo.langConfig['AddSuccess'])
        this.getQuestionList()
      },err => {
        console.log('err', err)
      }).finally(()=>{
        this.lockApi.question = false
        this.newStoreInfo.loading = {
          isShow: false,
          showType: 2
        }
      })
    },

    // 获取工单列表
    getQuestionList(){
      let {appId, userId} = this.newStoreInfo.userInfo
      let params = {
        appId,
        userId
      }
      getQuestionList(params).then(res=> {
        this.questionList = res.data.sort((itemA, itemB) => (new Date(itemB.updateTime) -new Date(itemA.updateTime) ))
        this.solvingQsList = this.questionList.filter(item => item.status === 0 || item.status === 1)
        this.solvedQsList = this.questionList.filter(item => item.status === 2)
      })
    },
    
    // 获取客服语言配置
    getCustomer() {
      let url = '/v1/customer/getLanguages/'+ this.newStoreInfo.userInfo.appId
      getCustomerLanguage(url).then((res) => {
        if (res.code === 200) {
          this.csType.text = ''
          this.customerList = res.data.map(item=>({id:item.language, text: item.name}))
          this.customerList.map((item) => {
            if (item.id === this.newStoreInfo.userInfo.language) {
              this.csType.text = item.text
            }
          })
          if (this.csType.text === '') {
            this.csType.text = 'English'
            this.csType.id = 'en'
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$mainColor: #599d00;

.qs-list {
  // 提问
  .subtitle {
    background-color: #999;
    width: auto;
    margin: 20px 10px 0;
    padding: 5px 15px;
    border-radius: 5px;
    color: #fff;
  }
  .btn-group {
    display: flex;
    width: 300px;
    margin: 5px auto 10px;
    justify-content: space-between;
    color: #fff;
    text-align: center;
    .btn-select {
      width: 40%;
      height: 30px;
      line-height: 30px;
      background-color: #999;
      border-radius: 5px;
      &.active {
        background-color: $mainColor;
      }
    }
  }
  .box-qs-list {
    height: calc(100vh - 6rem);
    min-height: 200px;
    overflow: auto;
  }
  .qs-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .qs-title {
      color: $mainColor;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      margin-right: 10px;
      flex: 1;
    }
    .qs-time {
      font-size: 10px;
    }
  }

  // 提交问题
  .qs-form {
    padding: 0 15px;
    margin-top: 15px;
    .item-title {
      color: $mainColor;
      font-size: 14px;
      font-weight: bolder;
    }
    .item-content {
      border: 1px solid $mainColor;
      height: 30px;
      padding: 1px 10px 1px 15px;
      border-radius: 10px;
      margin: 10px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &.item-text {
        height: auto;
      }
      .item-input {
        padding: 0;
      }
      .item-textarea {
        padding: 0;
      }
    }
    .item-file {
      margin: 10px 0;
    }
  }
  .btn-commit {
    width: 90%;
    background-color: $mainColor;
    height: 40px;
    line-height: 40px;
    border-radius: 10px;
    text-align: center;
    color: #fff;
    margin: 0 auto;
    font-size: 14px;
  }
}
</style>
